import { Injectable } from '@angular/core';
import { ModuleConfig } from '@app/core/services/modules-api.service';

@Injectable()
export abstract class IModuleParamSubstitution {
    abstract process(mod: ModuleConfig): void;
}
